import { createContext } from 'react';

export const DraggableActionContext = createContext({
    markAsDone: null
});
